import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { isNil } from 'lodash';
import Detail from '../views/Detail.vue';
import Search from '../views/Search.vue';
import Policy from '../views/Policy.vue';
import About from '../views/About.vue';
import Contact from '../views/Contact.vue';
import ContactSuccess from '../views/ContactSuccess.vue';
import Terms from '../views/Terms.vue';

import CheckLogin from '../views/CheckLogin.vue';
import Home from '../views/Home.vue';
import store from '../store/index';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/check-login',
    name: 'check-login',
    component: CheckLogin,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "client-chunk-login" */ '../views/Login.vue'),
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/contactSuccess',
    name: 'ContactSuccess',
    component: ContactSuccess,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/detail',
    name: 'detail',
    component: Detail,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/policy',
    name: 'Policy',
    component: Policy,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/terms',
    name: 'terms',
    component: Policy,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/search/:categoryname/:subcatagoryname/:categoryid/:pagenum',
    name: 'search',
    component: Search,
    meta: {
      authNotRequired: true,
    },
  },
  {
    path: '/products',
    name: 'products',
    component: () => import(/* webpackChunkName: "client-chunk-products" */ '../views/Products.vue'),
  },
  {
    path: '/products/:id',
    name: 'product',
    props: true,
    component: () => import(/* webpackChunkName: "client-chunk-product-details" */ '../views/Product.vue'),
  },
  { path: '*', redirect: '/home' },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    !(to.meta && to.meta.authNotRequired) &&
    isNil(store.state.authentication.user)
  ) {
    const path =
      store.state.authentication.user === null ? '/login' : '/check-login';
    return next(`${path}?redirectUrl=${to.path}`);
  }
  next();
});

export default router;
